import {
  ButtonPrimary,
  ButtonSecondary,
  SidePanel,
  SidePanelType,
} from '@ui/src';
import { useAppSelector } from '@store';
import useCreate from '../hooks/use-create';
import CreateReportForm from '../../../components/fintrac/create-form';

const CreateReport = ({ type }: { type: 'eftr' | 'lvctr' }) => {
  const { currencies, paymentTypes } = useAppSelector((state) => state.root);
  const { incomingTransactions, incomingTransactionsPagination } =
    useAppSelector((state) => state.fintrac.list);

  const {
    panelIsOpen,
    handleClose,
    onSubmit,
    globalError,
    control,
    errors,
    onRowSelect,
    formattedData,
    transactionsTableVisible,
    isLoading,
    isFetching,
    filtersComponent,
    tableHandleSubmit,
    onClear,
    onTableSetPage,
    onSort,
    errorList,
    onTableFilter,
    sort,
    filters,
    selectedTransactionsIds,
    createReportInProgress,
    addTransactionsInProgress,
  } = useCreate({
    transactions: incomingTransactions,
    currencies,
    type,
    paymentTypes,
  });

  return (
    <SidePanel
      title={`Create ${type === 'eftr' ? 'EFTR' : 'LVCTR'} report`}
      isOpen={panelIsOpen}
      onClose={handleClose}
      sidepanelExpandedKey="create-report-panel"
      errorSidepanel={globalError}
      type={SidePanelType.Transactions}
      footer={
        <>
          <ButtonPrimary
            text={
              addTransactionsInProgress || createReportInProgress
                ? 'Loading...'
                : 'Create report'
            }
            onClick={onSubmit}
            bold
            disabled={addTransactionsInProgress || createReportInProgress}
          />
          <ButtonSecondary
            text="Close"
            onClick={handleClose}
            className="button-white"
            bold
          />
        </>
      }
      expanded
      closeOnClickOutside
    >
      <CreateReportForm
        control={control}
        errors={errors}
        eftrTransactions={formattedData}
        eftrTransactionsPagination={incomingTransactionsPagination}
        onRowSelect={onRowSelect}
        transactionsTableVisible={transactionsTableVisible}
        transactionsIsLoading={isLoading}
        transactionsIsFetching={isFetching}
        filtersComponent={filtersComponent}
        tableHandleSubmit={tableHandleSubmit}
        onClear={onClear}
        onTableSetPage={onTableSetPage}
        onSort={onSort}
        errorList={errorList}
        onTableFilter={onTableFilter}
        sort={sort}
        filters={filters}
        selectedTransactionsIds={selectedTransactionsIds}
      />
    </SidePanel>
  );
};

export default CreateReport;
